import 'swiper/css';
import '../scss/main.scss';
import '../utils/hello';
import '../components/slider-swiper';
import '../components/top-bar';
import '../components/menu';
import '../components/logout';
import '../components/header.js';

import { variantOnChange } from '../components/variants-product';
import {
  btnAddToCart,
  deleteItem,
  onChangeItemCart,
  onLoadEmptyCart,
  openCartFromHeader,
  openCloseCart,
  getCart
} from '../components/cart';
import { setQuantity } from '../utils/input-quantity';
import { openAccordion } from '../utils/accordion';
import { filter } from "../components/filter";
import sliderHeroComponent from '../components/hero';
import initBestSellers from "../components/nos-meilleures";
import initProductsSwiper from "../components/article-product-block";
import initReviews from '../components/reviews';
import initCarousel from '../components/products-carousel';
import initPopularArticlesSwiper from "../components/popular-articles";
import initCollectionNavCarousel from '../components/collection-nav';
import { collectionMoreInfo } from '../components/collection';
import { validateNewsLetter } from '../components/newsletter';
import "../components/stories-cards-slider";
import { onClickProductCard, onLoadAndResizeProductCard } from '../components/modal-cart';
import { assignClassToEmptyText } from '../components/content-page';
import { initOptionsToggle, initBundleOptions, initKlaviyoBtn } from "../components/jolly-option-toggle";
import "../components/jolly-video";
import "../components/customer-portal";
import "../components/sticky-bar";
import "../components/facets";
import "../components/sort-custom-select";

import { initCustomerPortalSubscriptionInfos, repeatOrder } from '../components/customer-portal';

if (shopify_variables.templateName.includes('profile')) {
  initCustomerPortalSubscriptionInfos();
} 

getCart();

filter();
variantOnChange('.js-variants');

onLoadEmptyCart();

document.addEventListener('DOMContentLoaded', () => {
  btnAddToCart('.add-product-cart');
  btnAddToCart('.add-product-cart-upsell');
})

openCloseCart();
openCartFromHeader();
deleteItem();
setQuantity();
onChangeItemCart();
openAccordion();

sliderHeroComponent();
initBestSellers();
initProductsSwiper();
initReviews();
initCarousel();
initPopularArticlesSwiper();
initCollectionNavCarousel();
// initReviewsSwiper();

validateNewsLetter();
onClickProductCard();
onLoadAndResizeProductCard();
assignClassToEmptyText();

initOptionsToggle();
initBundleOptions('#main-product__detail .add-product-cart ');
initKlaviyoBtn();


document.addEventListener('sendForm', function () {
  document.querySelector('button.btn-add-to-cart').click();
})